import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { h, Component, createRef } from 'preact';
var TRANSITION_MS = 300;

var FadeIn =
/*#__PURE__*/
function (_Component) {
  _inherits(FadeIn, _Component);

  function FadeIn() {
    var _this;

    _classCallCheck(this, FadeIn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FadeIn).apply(this, arguments));
    _this.ref = createRef();
    return _this;
  }

  _createClass(FadeIn, [{
    key: "componentWillEnter",
    value: function componentWillEnter(callback) {
      this.ref.current.style.opacity = '1';
      this.ref.current.style.transform = 'none';
      setTimeout(callback, TRANSITION_MS);
    }
  }, {
    key: "componentWillLeave",
    value: function componentWillLeave(callback) {
      this.ref.current.style.opacity = '0';
      this.ref.current.style.transform = 'translateY(350%)';
      setTimeout(callback, TRANSITION_MS);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return h("div", {
        className: "uppy-Informer-animated",
        ref: this.ref
      }, children);
    }
  }]);

  return FadeIn;
}(Component);

export { FadeIn as default };